import map from '../../assets/icons/map.svg';
import phone from '../../assets/icons/phone.svg';
import email from '../../assets/icons/email.svg';


export const contact = [
  {
    id: 1,
    text: `329 Queensberry Street, North Melbourne VIC 3051, Australia.`,
    icon: map,
    link: '#',
  },
  {
    id: 2,
    text: 'support@houzing.com',
    icon: email,
    link: '#',
  },
  {
    id: 3,
    text: '123 456 7890',
    icon: phone,
    link: '#',
  },
];

export default contact;



export const discover = [
  {
    id: 1,
    text: 'Chicago',
    link: '#',
  },
  {
    id: 2,
    text: 'Terms & Conditions',
    link: '#',
  },
  {
    id: 3,
    text: 'Miami',
    link: '#',
  },
  {
    id: 4,
    text: 'New York',
    link: '#',
  },
];


export const quickLInks = [
  {
    id: 1,
    text: 'About Us',
    link: '#',
  },
  {
    id: 2,
    text: 'Los Angeles',
    link: '#',
  },
  {
    id: 3,
    text: `User's Guide`,
    link: '#',
  },
  {
    id: 4,
    text: 'Support Center',
    link: '#',
  },
  {
    id: 5,
    text: 'Support Center',
    link: '#',
  },
  {
    id: 6,
    text: 'Press Info',
    link: '#',
  },
  {
    id: 7,
    text: 'Contact Us',
    link: '#',
  },
];


export const Lists = [
  {
    id: 1,
    text: 'Apartments',
    link: '#',
  },
  {
    id: 2,
    text: 'Condos',
    link: '#',
  },
  {
    id: 3,
    text: `Houses`,
    link: '#',
  },
  {
    id: 4,
    text: 'Offices',
    link: '#',
  },
  {
    id: 5,
    text: 'Retail',
    link: '#',
  },
  {
    id: 6,
    text: 'Villas',
    link: '#',
  },
 
];


export const subscribe = [
  {
    id: 1,
    text: `We don't send spam so don't worry.`,
    link: '#',
  },
];



// export const socialIcons = [
//   {
//     icon: facebook,
//     link: 'https://www.facebook.com/',
//   },
//   {
//     icon: twitter,
//     link: 'https://www.twitter.com/',
//   },
//   {
//     icon: instagram,
//     link: 'https://www.instagram.com/',
//   },
//   {
//     icon: linkedin,
//     link: 'https://www.linkedin.com/',
//   },
// ];
